/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { OverviewZoneDto } from '../../models/overview-zone-dto';

export interface GetOverviewFacility$Params {
  facilityId: number;
  date?: string;
  isLive?: boolean;
}

export function getOverviewFacility(http: HttpClient, rootUrl: string, params: GetOverviewFacility$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<OverviewZoneDto>>> {
  const rb = new RequestBuilder(rootUrl, getOverviewFacility.PATH, 'get');
  if (params) {
    rb.path('facilityId', params.facilityId, {});
    rb.query('date', params.date, {});
    rb.query('isLive', params.isLive, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<OverviewZoneDto>>;
    })
  );
}

getOverviewFacility.PATH = '/api/facilitygroup/overview/facilityId/{facilityId}';
